import React from 'react';
import { FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';

export const Pagination = ({
  table, // Receive the full table instance
  dataLength, // Total records from backend
  theme,
}) => {
  const themeColor = theme?.themeColor || 'primary';

  // Get state and methods from the table instance
  const {
      getState,
      setPageIndex,
      setPageSize,
      previousPage,
      nextPage,
      getCanPreviousPage,
      getCanNextPage,
      getPageCount, // Use getPageCount()
  } = table;

  const { pageIndex, pageSize } = getState().pagination;
  const pageCount = getPageCount(); // Get total pages calculated by the table

  // Calculate record range
  const startRecord = pageIndex * pageSize + 1;
  const endRecord = Math.min((pageIndex + 1) * pageSize, dataLength);

  // Handlers using table methods
  const handleGoToPage = (index) => {
    setPageIndex(index); // TanStack Table handles the state update and triggers onPaginationChange
  };

  const handlePageSizeChange = (e) => {
    const newSize = Number(e.target.value);
    setPageSize(newSize); // TanStack Table handles the state update and triggers onPaginationChange
  };

  // Conditional rendering logic (remains similar)
  if (pageCount <= 0 && dataLength <= 0) return null;
  // if (pageCount === 1 && dataLength <= pageSize) return null; // Optional

  return (
    <div className="mt-4 py-3 flex flex-col sm:flex-row items-center justify-between text-sm text-gray-600 dark:text-gray-400 border-t border-gray-200 dark:border-gray-700 px-2">
      {/* Info Record */}
      <div className="mb-2 sm:mb-0">
        {dataLength > 0 ? (
          <span>Mostra {startRecord} - {endRecord} di {dataLength} record</span>
        ) : ( <span>Nessun record</span> )}
      </div>

      <div className="flex items-center space-x-2">
        {/* Page Size Selector */}
        <span className="hidden md:inline">Record per pagina:</span>
        <select
          value={pageSize}
          onChange={handlePageSizeChange}
          className="p-1 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-xs focus:outline-none focus:ring-1 focus:ring-primary dark:focus:ring-primary-dark"
        >
          {/* CHANGED: Put 25 first in the list since it's now the default */}
          {[25, 10, 50, 100].map(size => ( <option key={size} value={size}>{size}</option> ))}
        </select>

        {/* Page Navigation Controls */}
        <div className="flex items-center space-x-1">
          <button
            onClick={() => handleGoToPage(0)} // Use handler
            disabled={!getCanPreviousPage()} // Use getter
            className={`p-1 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 dark:hover:bg-gray-700`}
            aria-label="Prima pagina"
          > <FaAngleDoubleLeft /> </button>
          <button
            onClick={() => previousPage()} // Use direct method
            disabled={!getCanPreviousPage()} // Use getter
            className={`p-1 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 dark:hover:bg-gray-700`}
            aria-label="Pagina precedente"
          > <FaAngleLeft /> </button>
          <span className="px-2">
            Pagina{' '}<strong>{pageIndex + 1} di {pageCount > 0 ? pageCount : 1}</strong>
          </span>
          <button
            onClick={() => nextPage()} // Use direct method
            disabled={!getCanNextPage()} // Use getter
            className={`p-1 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 dark:hover:bg-gray-700`}
            aria-label="Pagina successiva"
          > <FaAngleRight /> </button>
          <button
            onClick={() => handleGoToPage(pageCount - 1)} // Use handler
            disabled={!getCanNextPage() || pageCount <= 0}
            className={`p-1 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 dark:hover:bg-gray-700`}
            aria-label="Ultima pagina"
          > <FaAngleDoubleRight /> </button>
        </div>
        {/* Optional Go To Page Input (remains similar, uses handleGoToPage) */}
      </div>
    </div>
  );
};